import React, { useEffect, useState }from "react";
import { Modal, Select, Spin, notification } from "antd";
import _ from 'lodash';
import styled from "styled-components";
import { Icon } from 'dlweb-components';
import UserPicker from "../../UserPicker";

const ReplacementUserModal = ({ visible, onOk, onCancel, onSelect, usersInWorkflow, userIds }) => {
  
  const [disabled, setDisabled] = useState(true)

  useEffect(() => {
    setDisabled(true)
  }, [visible])

  const _onSelect = (selectedUser) => {
      onSelect(selectedUser);
      setDisabled(false);
  }

  return (
    <Modal
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      width={575}
      destroyOnClose={true}
      maskClosable={false}
      okButtonProps={{disabled: disabled}}
      title={<>
                <Icon type='exclamation-circle' size="lg" style={{color: 'var(--warning-color)', marginRight: '10px'}}/>
                Please select replacement user
            </>}
    >
			<div>
				<span>
          The following users are participants in a workflow process or an event subscription:
        <UserList>
          {usersInWorkflow.map(i => (
              <div key={i}>{i}</div>
            ))
          }
        </UserList>
          Please select a replacement user before continuing.
				</span>
        <UserPicker blacklist={userIds} onSelect={_onSelect}/>
			</div>
    </Modal>
  );
};

const UserList = styled.div`
  margin: 10px 0;
  font-weight: bold;
  max-height: 100px;
  overflow-y: auto;
`

export default ReplacementUserModal;
